export function isPC() {
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ../src/service/utils.ts